import React from "react";
import { Outlet } from "react-router-dom";
import Footer from "../../components/common/Footer";

import "./styles.css";

interface ILayoutProps {}

const AuthLayout: React.FC<ILayoutProps> = () => {
    return (
        <div className="layout-wrap">
            <div className="layout">
                <div className="layout-content">
                    <Outlet />
                </div>
                <Footer />
            </div>
        </div>
    );
};

export default AuthLayout;
